// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsLeadWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { CappsLeadWebApiHandler_sendLeadOnApplicationSubmit } from '@zg-rentals/ts-capps-client';

import type {
  SendLeadOnApplicationSubmitRequestDto,
  SendLeadOnApplicationSubmitResponseDto,
} from '@zg-rentals/ts-capps-client';

export interface CappsLeadWebApiHandler_sendLeadOnApplicationSubmit_Args {
  postData: SendLeadOnApplicationSubmitRequestDto;
}

export type CappsLeadWebApiHandler_sendLeadOnApplicationSubmit_Options = UseMutationOptions<
  SendLeadOnApplicationSubmitResponseDto,
  unknown,
  CappsLeadWebApiHandler_sendLeadOnApplicationSubmit_Args
>;

export const useCappsLeadWebApiHandler_sendLeadOnApplicationSubmit = ({
  httpClient,
  ...options
}: Omit<CappsLeadWebApiHandler_sendLeadOnApplicationSubmit_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsLeadWebApiHandler_sendLeadOnApplicationSubmit_Args) =>
      CappsLeadWebApiHandler_sendLeadOnApplicationSubmit(args.postData, httpClient),
  });
};
